<template>
  <div id="app">
    <router-view :key="routerViewKey" />
    <cookie-banner />
  </div>
</template>

<script>
import CookieBanner from './components/ui/CookieBanner.vue';
export default {
  components: { CookieBanner },
  name: "App",
  title: "DSAGNet",
  computed: {
    routerViewKey() {
      const name = this.$route.name;
      const id = this.$route.params.id;
      if (
        (name === "gremium.verwaltung" || name === "gremium.verwaltung.sub") &&
        id
      ) {
        return `gremium-verwaltung-${id}`;
      }
      if (
        (name === "projektraum.verwaltung" ||
          name === "projektraum.verwaltung.sub") &&
        id
      ) {
        return `projektraum-verwaltung-${id}`;
      }
      return this.$route.fullPath;
    },
  },
  created() {
    this.$initPermissionStorage(this);
  },
};
</script>